import React from 'react'
import * as config from '../components/config'
import { ReactComponent as IconEasyPayLogo } from '../icons/epIconNew.svg';
import { Button,Typography, Grid,TextField, Link, InputAdornment} from '@mui/material';
import colors from '../components/colors'
import { useNavigate, useLocation }  from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';
import { useSelector, useDispatch } from 'react-redux';
import {selectUserInfo, setUserInfoAccountType} from '../features/userInfo/userInfoSlice'
import {setIsManualRegistration, selectLoginState, setShouldDisplayTwoFactorAuth,setShouldDisplayIdCardUpload,setShouldRedirectToIndividualOrExpressStep, setShouldDisplayTermsAndConditionsPopUp, resetLoginMessage, setIsOtpSuccessfullyResent, setShouldRedirectToPhoneValidation, setShouldRedirectToEmailValidation, setShouldRedirectToPasswordReset, setShouldRedirectToFifthStep, setLoginWhenFacephiDone, setHasPinBeenRegistered} from '../features/login/loginSlice'
import Lottie from "lottie-react";
import smallLoadingAnimation from '../icons/lottieAnimations/smallLoading.json'
import { sendGeneralRequest } from '../features/generalRequest'
import {selectGlobalDataState,setGeneralMessage, setToken, setGlobalDataAccountType, setIsLoggedIn, setUsername} from '../features/global/globalDataSlice'
import { Divider } from '@mui/material';
import { AcceptNewTermsAndConditions } from '../components/login/AcceptNewTermsAndConditions';
import TwoFactorAuthentication from '../components/login/TwoFactorAuthentication';
import {setIsValidatingPhone, setIsValidatingEmail, setRegistrationToken,setIsPickingIndividualOrExpressAccountType, setPhone, setAccountType, setPrefix, setCurrentRegistrationStep, setBirthdate, setGender, setFullName, setIdNumber, setIdExpiryDate, setIdPictureBase64, setIdPictureExtension, setDocNumber, setShouldFacePhiApply, setNationality, setCountryCode } from '../features/registration/registrationSlice';
import { useFormik } from 'formik';
import * as yup from 'yup'
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {texts} from '../components/general/texts'
import LoggedDevicesDialog from '../components/general/sca/LoggedDevicesDialog';


const validationSchema = yup.object({
    username: yup
        .string(texts["message-invalid-username"])
        .required(texts["message-invalid-username"]),
    password: yup
        .string(texts["message-invalid-password"])
        .required(texts["message-invalid-password"])
})

const Login = () => 
{
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const routerProps = useLocation()
    const userInfo = useSelector(selectUserInfo)
    const loginSliceState = useSelector(selectLoginState)
    const globalDataSliceState = useSelector(selectGlobalDataState)


    const formik = useFormik({
        initialValues:{
            username: '',
            password: '',
            serialNumber: 'test', 
            imei: 'test',
            deviceId: 'test',
            isFingerPrint: false,
            AppPlatform: config.default.appPlatform,
            AppVersionName: config.default.appVersion,
            DeviceName: config.default.userBrowserName,
            DeviceOS: config.default.userBrowserVersion
        },
        validationSchema: validationSchema,
        onSubmit: values => {
            dispatch(sendGeneralRequest({request: {_request: values}, baseUrlKey:'auth', endpoint: 'NewFlowLogin'})).then((response) => {
                if (response.payload?.response?.success) {
                    dispatch(setHasPinBeenRegistered(response.payload?.response?.hasPinRegistered));
                    dispatch(setUserInfoAccountType(response.payload?.response?.accountType))
                    dispatch(setGlobalDataAccountType(response.payload?.response?.accountType))
                }
            })
            dispatch(setUsername(values.username))
        }
    })

    const [showPassword, setShowPassword] = React.useState(false);

    React.useEffect(()=>{
        globalDataSliceState.isLoggedIn && navigate('/dashboard')
    },[globalDataSliceState.isLoggedIn])

    React.useEffect(()=>{
        if(loginSliceState.isLoginSuccessful)
        {
            dispatch(setToken(loginSliceState.token))
            dispatch(setUserInfoAccountType(loginSliceState.accountType))
            dispatch(setGlobalDataAccountType(loginSliceState.accountType))
            dispatch(setIsLoggedIn(true))   
            navigate('/dashboard')
        }
        loginSliceState.shouldDisplayTermsAndConditionsPopUp && dispatch(setShouldDisplayTermsAndConditionsPopUp(true))
        loginSliceState.shouldDisplayTwoFactorAuth && dispatch(setShouldDisplayTwoFactorAuth(true))

        if(loginSliceState.shouldDisplayIdCardUpload)
        {
            navigate('/idCardUpload')
            dispatch(setShouldDisplayIdCardUpload(false))
        }
        if(loginSliceState.shouldRedirectToPhoneValidation){  
            dispatch(setRegistrationToken(loginSliceState.token))
            dispatch(setPhone(loginSliceState.phone))
            dispatch(setAccountType(loginSliceState.accountType))
            dispatch(setIsValidatingPhone(true))
            dispatch(setShouldRedirectToPhoneValidation(false))
            dispatch(setPrefix(loginSliceState.prefix))
            navigate('/register')
        }
        if(loginSliceState.shouldRedirectToEmailValidation)
        {
            dispatch(setRegistrationToken(loginSliceState.token))
            dispatch(setIsValidatingEmail(true))
            dispatch(setShouldRedirectToEmailValidation(false))
            navigate('/register')
        }
        if(loginSliceState.shouldRedirectToPasswordReset)
        {
            navigate('/resetPassword')
            dispatch(setShouldRedirectToPasswordReset(false))
        }
        if(loginSliceState.shouldRedirectToIndividualOrExpressStep)
        {
            dispatch(setIsManualRegistration(loginSliceState.isManualRegistration))
            dispatch(setRegistrationToken(loginSliceState.token))
            dispatch(setAccountType(loginSliceState.accountType))
            dispatch(setIsPickingIndividualOrExpressAccountType(true))
            dispatch(setShouldRedirectToIndividualOrExpressStep(false))
            navigate('/register')
        }
        if(loginSliceState.shouldRedirectToFifthStep)
            {
                dispatch(setShouldRedirectToFifthStep(false));
                dispatch(setCurrentRegistrationStep(4));
                dispatch(setAccountType(loginSliceState.accountType));
                dispatch(setBirthdate(loginSliceState.clientData.birthDate));
                dispatch(setGender(loginSliceState.clientData.gender));
                dispatch(setFullName(loginSliceState.clientData.name + ' ' + loginSliceState.clientData.surname));
                dispatch(setIdNumber(loginSliceState.clientData.idNumber));
                dispatch(setIdExpiryDate(loginSliceState.clientData.expiryDate));
                dispatch(setIdPictureBase64(loginSliceState.clientData.image));
                dispatch(setNationality(loginSliceState.clientData.nationality));
                dispatch(setIdPictureExtension("jpg"));
                dispatch(setDocNumber(loginSliceState.clientData.documentNumber));
                dispatch(setCountryCode(loginSliceState.clientData.nationality));
                dispatch(setShouldFacePhiApply(true));
                dispatch(setToken(loginSliceState.token));
                dispatch(setLoginWhenFacephiDone(true));
                navigate('/register');
            }
        // if(loginSliceState.isOtpSuccessfullyResent)
        // {
        //     dispatch(setGeneralMessage({type: 'success', message: texts["message-otp-resend-success"]}))
        //     dispatch(setIsOtpSuccessfullyResent(false))
        // }
        if(loginSliceState.loginMessage !== '')
        {
            dispatch(setGeneralMessage({type: 'success', message: loginSliceState.loginMessage}))
            dispatch(resetLoginMessage())
        }
    },[loginSliceState.isLoginSuccessful,loginSliceState.shouldDisplayIdCardUpload, loginSliceState.shouldDisplayTermsAndConditionsPopUp,loginSliceState.shouldRedirectToPasswordReset, loginSliceState.shouldDisplayTwoFactorAuth,loginSliceState.loginMessage, loginSliceState.isOtpSuccessfullyResent, loginSliceState.shouldRedirectToPhoneValidation,loginSliceState.shouldRedirectToEmailValidation, loginSliceState.shouldRedirectToFifthStep])


    const handleSubmit = (e) => 
    {
        e.preventDefault()
        formik.handleSubmit()
    }


    return(
        <form>
            <Grid container >
                {routerProps.state === null ? null : <Snackbar open={true} autoHideDuration={6000} message={routerProps.state.message}/>}
                <Grid item md={6} xs={12} p={'1%'} mt={3}>
                    <IconEasyPayLogo width={'30%'}/>
                </Grid>
                <Grid container rowSpacing={5} pt={'10%'} >
                    <Grid container item md={12} xs={12}  justifyContent={'center'}>
                        <Typography sx={{fontFamily:'GerberaBold', color:colors.darkBlue, fontSize:'1.8rem'}}>{texts["message-welcome"]}</Typography>
                    </Grid>
                    <Grid container item md={12} xs={12}  justifyContent={'center'}>
                        <TextField id="username" name="username" size='small' color='warning' label={texts['placeholder-user']} sx={{width:'20%', '@media (max-width: 899px )' : {width:'60%'}}} onChange={formik.handleChange} value={formik.values.username} error={formik.touched.username && Boolean(formik.errors.username)} helperText={formik.touched.username && formik.errors.username} />
                    </Grid>
                    <Grid container item md={12} xs={12} justifyContent={'center'}>
                        <TextField autoComplete="off" id="password" name="password" size='small' type={showPassword ? "text" : "password"} color='warning' label={texts['placeholder-password']} sx={{width:'20%', '@media (max-width: 899px )' : {width:'60%'}}} onChange={formik.handleChange} value={formik.values.password} error={formik.touched.password && Boolean(formik.errors.password)} helperText={formik.touched.password && formik.errors.password} InputProps={{endAdornment:<InputAdornment sx={{mr:-2}} position="end"><Button disableRipple={true} onClick={() => setShowPassword(s => !s)} sx={{background:colors.white, color:colors.darkBlue, borderRadius:'100%', ':hover':{background:colors.white}}} >{showPassword === false && <VisibilityIcon />}{showPassword === true &&<VisibilityOffIcon />}</Button></InputAdornment>}} />
                    </Grid>
                    <Grid container item md={12} xs={12} justifyContent={'center'}>
                        <Button type='submit' disabled={userInfo.isLoading ? true : false} sx={{background:colors.gradientOrange, color:'white', width:'20%', fontFamily:'GerberaBold', textTransform:'none', '@media (max-width: 899px )' : {width:'60%'}}} onClick={(e)=>{handleSubmit(e)}}>{texts["button-login-short"]}</Button>                   
                    </Grid>
                    <Grid container item md={12} xs={12} justifyContent={'center'} padding={2} >
                        <Typography variant='body2' pr={1} sx={{color:colors.darkBlue, textAlign:'right', fontFamily:'GerberaLight'}}>{texts["prompt-no-account"]}</Typography>
                        <Link sx={{color:colors.orange, textDecorationColor:colors.orange, fontFamily:'GerberaBold',":hover":{textDecorationColor:'#FF8403', color:'#FF8403'}}} type={'button'} component='button' onClick={() => {navigate('/register')}} variant='body2'>{texts["prompt-no-account-create"]}</Link>
                    </Grid>           
                    <Grid container justifyContent={'center'} >
                        <Grid container item md={1} xs={1} >
                            {userInfo.isLoading && <Lottie animationData={smallLoadingAnimation} loop={true} autoplay={true}/>}    
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container item md={12} xs={12}  pr={'1%'} justifyContent={'center'} sx={{position: 'fixed', bottom: 10}} >
                    <Grid container item md={5} xs={5} justifyContent={'right'}  >
                        <Link underline='hover' sx={{color:colors.gray, textDecorationColor:colors.orange, fontFamily:'GerberaLight', ":hover":{textDecorationColor:colors.gray}}} onClick={() => {navigate('/popularQuestions')}} type={'button'} component='button' variant='body1'>{texts["title-faq"]}</Link>
                    </Grid>
                    <Grid container item md={2} xs={2} justifyContent={'center'} ml={'-7%'} >
                        <Divider sx={{background: colors.gray, height:'30px'}} orientation='vertical' />
                    </Grid>
                    <Grid container item md={5} xs={5} justifyContent={'left'} ml={'-7%'} >
                        <Link underline='hover' sx={{color:colors.gray, textDecorationColor:colors.orange, fontFamily:'GerberaLight',  ":hover":{textDecorationColor:colors.gray}}} onClick={() => {navigate('/forgotUserMain')}} type={'button'} component='button' variant='body1'>{texts["button-forgot-data"]}</Link>
                    </Grid>
                </Grid>     
                <AcceptNewTermsAndConditions/> 
                <TwoFactorAuthentication/> 
            </Grid>
            <LoggedDevicesDialog isDialogOpened={loginSliceState.showLoggedDevices}/>
        </form>
    )
}
export default Login